/**
 * Application type values corresponding to the application field in location payloads.
 */
export const APPLICATION_AGENT_511 = 'agent_511';
export const APPLICATION_ELS = 'els';
export const ALI_ADMIN = 'ali_admin';
export const APPLICATION_TEXT_TO_911 = 'text_to_911';
